var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldAbc = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.91 16.14c-1.14 0-2.047-.671-2.047-1.843 0-1.375 1.215-1.621 2.328-1.766 1.094-.14 1.547-.117 1.547-.562 0-.778-.41-1.235-1.265-1.235-.88 0-1.36.47-1.563.907l-.875-.313c.469-1.094 1.5-1.406 2.406-1.406.766 0 2.22.219 2.22 2.125V16h-.923v-.812h-.047c-.187.39-.734.953-1.78.953m.14-.828c1.095 0 1.688-.734 1.688-1.484v-.844c-.156.188-1.203.297-1.593.344-.72.094-1.36.313-1.36 1.016 0 .64.531.969 1.266.969M9.799 16V8h.922v2.953h.078c.203-.312.562-1.031 1.734-1.031 1.516 0 2.563 1.203 2.563 3.094 0 1.906-1.047 3.109-2.547 3.109-1.157 0-1.547-.719-1.75-1.047h-.11V16zm.906-3c0 1.36.61 2.297 1.719 2.297 1.156 0 1.75-1.016 1.75-2.297 0-1.266-.578-2.25-1.75-2.25-1.125 0-1.72.906-1.72 2.25m7.684 3.125c-1.687 0-2.719-1.297-2.719-3.094 0-1.828 1.079-3.11 2.704-3.11 1.265 0 2.218.75 2.375 1.876h-.922c-.14-.547-.625-1.047-1.438-1.047-1.078 0-1.797.89-1.797 2.25 0 1.39.703 2.297 1.797 2.297.719 0 1.266-.39 1.438-1.047h.922c-.157 1.063-1.032 1.875-2.36 1.875",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldAbc);
export default ForwardRef;